import { createFileRoute, redirect } from "@tanstack/react-router";

/** A former canvas address, kept because a pasted address may never stop resolving. */
export const Route = createFileRoute("/play/$code")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$address/$role", params: { address: params.code, role: "viewer" } });
  },
});
